<template lang="html">
  <booking-resources
    v-bind="$attrs"
    :headers="headers"
    :types="types"
    :createNewItem="createNewItem"
  >

    <template v-slot:itemForm="slotProps">
      <booking-resource-form v-bind="slotProps">

        <template v-slot:append="{item, required, validNumber}">
          <v-text-field
            label="Seats"
            v-model="item.seats"
            type="tel"
            autocomplete="off"
            :rules="[required]"
          />
          <v-select
            label="Shape"
            v-model="item.shape"
            :items="shapes"
            :rules="[required]"
          />
          <v-row dense>
            <v-col cols="12" sm="6">
              <number-input
                label="Width (m)"
                v-model="item.width"
                :rules="[required, validNumber]"
              />
            </v-col>
            <v-col cols="12" sm="6">
              <number-input
                label="Length (m)"
                v-model="item.length"
                :rules="[required, validNumber]"
              />
            </v-col>
          </v-row>
        </template>

      </booking-resource-form>
    </template>

  </booking-resources>
</template>

<script>
import {BookingResources, BookingResourceForm, NumberInput} from 'dync-booking';

export default {
  inheritAttrs: false,
  data() {
    return {
      types: [
        {
          text: 'Table',
          value: 'table'
        }
      ],
      shapes: [
        {
          text: 'Rectangle',
          value: 'rectangle'
        },
        {
          text: 'Round',
          value: 'round'
        }
      ],
      headers: [
        {
          text: 'Title',
          value: 'title'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Number',
          value: 'number'
        },
        {
          text: 'Seats',
          value: 'seats'
        },
        {
          text: 'Bookable',
          value: 'bookable'
        }
      ]
    }
  },
  methods: {
    createNewItem() {
      return {
        type: 'table',
        shape: 'rectangle'
      };
    }
  },
  components: {
    BookingResources,
    BookingResourceForm,
    NumberInput
  }
}
</script>

<style lang="css" scoped>
</style>
